import { createContext } from "react";

export const HomeLayoutContext = createContext({})